export const TYPES = [
  {
    key: "format",
    value: "Format",
  },
  {
    key: "minify",
    value: "Minify",
  },
];
